// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"welcome-module--wrapper--1pT6d","content":"welcome-module--content--XkSch","image":"welcome-module--image--1kcex"};